import { Box, Flex } from '@chakra-ui/layout'
import { Button } from '@ubirider/pick-component-library'
import { signOut } from 'firebase/auth'
import firebase from '../../../../Firebase'
import { RouteButton } from './components/RouteButton'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import homeIcon from '../../../../assets/home.svg'
import travelIcon from '../../../../assets/operation.svg'
import cardIcon from '../../../../assets/credit_card.svg'
import carIcon from '../../../../assets/car.svg'
import ticketIcon from '../../../../assets/ticketing.svg'
import accountIcon from '../../../../assets/settings.svg'
import supportIcon from '../../../../assets/message-circle.svg'

export function Menu() {
  const { t } = useTranslation()

  const [loading, setLoading] = useState(false)

  const logout = async () => {
    setLoading(true)
    await signOut(firebase)
  }

  return (
    <Box>
      <Flex
        display={{ base: 'block', sm: 'none', md: 'none', lg: 'block' }}
        gap='24px'
        bg='neutral.100'
        rounded='8px'
        padding='16px'
        align='flex-start'
        minW={{ base: '332px', lg: '332px', xl: '332px' }}
      >
        <Flex gap='24px' direction='column'>
          <Flex direction='column' align='flex-start'>
            <RouteButton icon={homeIcon} label='home.home' route='/home' />
            <RouteButton icon={travelIcon} label='travel_history.travel_history' route='/travel-history' />
            <RouteButton icon={cardIcon} label='demo.wallet' route='/wallet' />
            <RouteButton icon={carIcon} label='acqua_vias.common_vehicles' route='/vehicles' />
            <RouteButton icon={ticketIcon} label='acqua_vias.common_tickets' route='/tickets' />
          </Flex>

          <Flex direction='column' align='flex-start'>
            <RouteButton icon={accountIcon} label='account.account' route='/account' />
            <RouteButton icon={supportIcon} label='acqua_vias.common_support' route='/support' />
          </Flex>

          <Flex>
            <Button
              onClick={() => {
                logout()
              }}
              loading={loading}
              style='outline'
              type='secondary'
              label={t('home.logout_button')}
              css={{ width: '100%' }}
            />
          </Flex>
        </Flex>
      </Flex>
    </Box>
  )
}
